<script setup lang="ts">
import { type FragmentType, graphql } from '~/gql';
import { SeminarApplicationStatus } from '~/gql/graphql';

const props = defineProps<{
  seminar: FragmentType<typeof SeminarFragment>;
}>();

const SeminarFragment = graphql(`
  fragment SeminarDetailTemplateSeminarDetailSummarySeminar on Seminar {
    id
    applicationFee
    sponsor
    schedules {
      applicationStatus
      location
    }
  }
`);

const seminar = useComputedFragment(SeminarFragment, () => props.seminar);

const uniq = <T,>(lst: T[]) => {
  const map = new Map<T, undefined>();
  lst.forEach((elm) => (map.has(elm) ? null : map.set(elm, undefined)));
  return [...map.keys()];
};
const locations = computed(() =>
  uniq(
    seminar.value.schedules
      .filter(
        (s) => s.applicationStatus === SeminarApplicationStatus.Applicable
      )
      .map((s) => s.location)
  )
);
</script>

<template>
  <div>
    <table :class="$style.table">
      <tbody>
        <tr v-if="locations.length > 0">
          <th>場所</th>
          <td>{{ locations.join('、') }}</td>
        </tr>
        <tr>
          <th>参加費</th>
          <td v-if="seminar.applicationFee === 0">無料</td>
          <td v-else>{{ seminar.applicationFee }}円</td>
        </tr>
        <tr>
          <th>主催</th>
          <td>{{ seminar.sponsor }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style module lang="scss">
.table {
  border-spacing: 0;
  & > tr:nth-child(n + 1) {
    margin-top: 8px;
  }

  & th {
    vertical-align: top;
    text-align: start;
    font-size: 16px;
    line-height: 1.8;
    white-space: nowrap;
  }

  & td {
    font-size: 16px;
    line-height: 1.8;
    padding-left: 10px;
  }
}
</style>
